import { useEffect, useState } from 'react';
import { AppState } from 'react-native';
import DeviceInfo, { useBatteryLevel, usePowerState } from 'react-native-device-info';
import { TBatteryStatus } from '@shared/types';

export const toBatteryPercentage = (level: number | null): number | null =>
  level === null || level < 0 ? null : Math.round(level * 100);

export const useBatteryStatus = (): TBatteryStatus => {
  const eventLevel = useBatteryLevel();
  const { batteryState } = usePowerState();
  const [level, setLevel] = useState<number | null>(null);

  useEffect(() => {
    if (eventLevel !== null) setLevel(eventLevel);
  }, [eventLevel]);

  useEffect(() => {
    const refresh = () => DeviceInfo.getBatteryLevel().then(setLevel).catch(() => undefined);
    refresh();
    const subscription = AppState.addEventListener('change', (state) => {
      if (state === 'active') refresh();
    });
    return () => subscription.remove();
  }, []);

  return { percentage: toBatteryPercentage(level), isCharging: batteryState === 'charging' };
};
